var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('skeleton-box',{staticClass:"rounded",attrs:{"height":"100px","width":"100px"}}):_c('z-profile-image',{attrs:{"type":"driver","size":_vm.size,"image":_vm.profileImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }